var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27778",
    "data-name": "Rectangle 27778",
    width: 13,
    height: 13,
    transform: "translate(826 448)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_574",
    "data-name": "Mask Group 574",
    transform: "translate(-826 -448)",
    clipPath: "url(edit-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_39_",
    "data-name": "svgexport-6 (39)",
    transform: "translate(826 448.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11127",
    "data-name": "Group 11127",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11313",
    "data-name": "Path 11313",
    d: "M8.084,2.2,10.728,4.84,4.034,11.534,1.391,8.889Zm4.651-.638L11.556.378A1.17,1.17,0,0,0,9.9.378l-1.13,1.13,2.644,2.644,1.318-1.318A.9.9,0,0,0,12.735,1.558ZM.007,12.606a.3.3,0,0,0,.364.358l2.947-.714L.675,9.606Z",
    transform: "translate(0 -0.037)",
    fill: "#8391a2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.bf0945f348910d2a99f6035cf5a868f2.svg";
export { ForwardRef as ReactComponent };